import React from "react";

import { Container, Row, Col } from "reactstrap";
import Layout from "./Layout";

const Error = () => {
  return (
    <Layout>
      <Container>
        <Row className="mt-4">
          <Col>
            <h3>An Error Occured.</h3>
            We're sorry, your request di not go through. Please try again later.
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default Error;
